import { accordion } from './modules/accordion';
import { gallery } from './modules/gallery';
import { header } from './modules/header';
import { headerNav } from './modules/headerNav';
import { loading } from './modules/loading';
import { modal } from './modules/modal';
import { pagetop } from './modules/pagetop';
import { scrollAddClass } from './modules/scrollAddClass';
import { slideScroll } from './modules/slideScroll';

accordion();
gallery();
header();
headerNav();
loading();
modal();
pagetop();
slideScroll();
scrollAddClass();
